export const LaunchCamera = /*async*/ () => {
    return null;
};

export const LaunchGallery = /*async*/ () => {
    return null;
};
